import React from 'react';
import Filters from './Filters';
import DigitsBox from './DigitsBox';

const Widgets = () => {

  return (
    <div className="widget">
      <div className="container col-md-7">
          <div>
            <Filters/>
          </div>
      </div>
      <div className="digit-paper col-md-5">
        <div className="inner digits">
          <DigitsBox/>
        </div>
      </div>
    </div>
  );

};
export default Widgets;
